import { Div, Collection, Text, TableBuilder, TextInput, NumberInput, Checkbox, Link, Select } from "@tblabs/truffle";
import { Cost, Discount } from "../../Services/Basket/Discount";
import { DiscountTarget, DiscountType } from "../../Services/Basket/RawCost";
import { Box } from "../../Components/Utils/Box";


export class DiscountsTable extends Div
{
    constructor(discounts: Collection<Cost>)
    {
        super();

        this.Append(
            new TableBuilder(discounts)
                .AddColumn("Typ i cel", x => [
                    new Select(x.Type, [DiscountType.Percent, DiscountType.LimitedPercent, DiscountType.FixedPrice]),
                    new Select(x.Target, [DiscountTarget.WholeBasket, DiscountTarget.RentalItems, DiscountTarget.SaleItems, DiscountTarget.SpecificItem]).MarginTop(4)
                ])
                .AddColumn("Nazwa i opis", x => [
                    new TextInput(x.Name),
                    new TextInput(x.Description).MarginTop(4)
                ])
                .AddColumn("Kod i widoczność", x => [
                    new TextInput(x.Code),
                    new Checkbox(x.IsVisible, "Pokaż na stronie").MarginTop(4)
                ])
                .AddColumn("% lub wartość oraz limit", x => [
                    new NumberInput(x.Value).Step(1).Min(1).Max(100).WidthPercent(80).MarginLeft(4),
                    new Text(x.Type, v => v == DiscountType.FixedPrice ? " zł" : " %"),
                    new Box("max ", new NumberInput(x.Limit).Step(1).Min(0).MarginTop(4).WidthPercent(60), " zł")
                        .VisibleWhen(x.Type, v => v == DiscountType.LimitedPercent)
                ])
                .AddColumn("", x => new Link("✖️").OnClick(() => discounts.Remove(x)))
                .Build(),
            new Link("➕ Dodaj")
                .OnClick(() => discounts.Add(
                    new Discount({
                        Name: "nowa zniżka",
                        Code: Math.random().toString(16).substring(2, 6).toUpperCase(),
                        Value: 10,
                        IsVisible: true,
                        Target: DiscountTarget.WholeBasket,
                        Type: DiscountType.Percent,
                        Limit: 300,
                    })))
        );
    }
}
